export default __webpack_public_path__ + "static/media/My-Layout-wallpaper.ed9672f1.png";